/* src/utils/flags.js
 * Feature flags for roadmap-layer UI (Layer C in GOCTA-RESKIN-IMPLEMENTATION-PLAN.md §1).
 * Default OFF — flip only once the backing backend/product decision ships.
 */

/** Inbox SMS composer — self-gates per workspace on sms_numbers active + A2P approved. */
export const INBOX_SMS_COMPOSER = true;

/** SMS form opt-in builder toggle. Phase 1c/A2P approval un-gates the builder toggle. */
export const FORM_SMS_OPT_IN = true;

/** Manual email reply — Step B shipped. */
export const INBOX_EMAIL_COMPOSER = true;

/** SMS self-serve onboarding wizard — admin-only until B3 launch flag. */
export const SMS_ONBOARDING_LAUNCHED = true;

/** Next-best-action suggestion cards — roadmap layer 1, no backend. */
export const NEXT_BEST_ACTION = false;
